export default __webpack_public_path__ + "static/waterfall-light-b2895adef08971955b89c6fcb35ea851.gif";